<template>
  <div>
    <CustomerReceivedInvoicesFilters
      sender="HOST"
      :isDownloading="isDownloading"
      :downloadError="downloadError"
      :invoicesLength="customerHostInvoices.length"
      @downloadInvoiceZip="downloadInvoiceZip"
    />
    <v-data-table
      :no-data-text="$t('table.noResults')"
      :headers="headers"
      :items="customerHostInvoices"
      class="clickable"
      hide-default-footer
      calculate-widths
    >
      <template v-slot:item.host="{ item }">
        <span>
          {{ item.host ? item.host.name : '---' }}
        </span>
      </template>
      <template v-slot:item.total="{ item }">
        <span>
          {{ item.total ? formatMoney(item.total) : '---' }}
        </span>
      </template>
      <template v-slot:item.created_at="{ item }">
        <span>
          {{ item.created_at ? formatDate(item.created_at) : '---' }}
        </span>
      </template>
      <template v-slot:item.file_response="{ item }">
        <v-btn v-if="item.file_response" @click="downloadInvoice(item.file_response.url)" color="grey" elevation="0" icon>
          <IconTooltip
            icon="mdi-download"
            :description="item.file_response.name"
            color="grey"
          />
        </v-btn>
        <span v-else>
          ---
        </span>
      </template>
    </v-data-table>

    <h-pagination :fetch="fetchCustomerInvoices" :requireOrderByFilter="false" :noBorders="true" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { catalogDateWithoutTime, catalogMonetary } from '@/util/catalog';
import { hostInvoiceHeaders } from '../customerInvoiceHeaders';
import { generateInvoiceZip } from '../customerInvoiceService';

import CustomerReceivedInvoicesFilters from './filters/CustomerReceivedInvoicesFilters';
import IconTooltip from '../../../../components/IconTooltip.vue';

export default {
  name: 'CustomerHostReceivedInvoices',

  components: {
    CustomerReceivedInvoicesFilters,
    IconTooltip,
  },

  computed: {
    ...mapGetters(['customerHostInvoices', 'isLoading', 'filters']),
  },

  data() {
    return {
      formatDate: catalogDateWithoutTime,
      formatMoney: catalogMonetary,
      headers: hostInvoiceHeaders,
      isDownloading: false,
      downloadError: null,
    };
  },

  methods: {
    ...mapActions(['fetchCustomerInvoices', 'showErrorMessage']),

    downloadInvoice(url) {
      window.open(url, '_blank');
    },

    async downloadInvoiceZip() {
      this.isDownloading = true;
      this.downloadError = null;

      try {
        if (!this.filters.creationStartDate || !this.filters.creationEndDate) {
          throw new Error('Filtros de data não estão definidos.');
        }

        const filterParams = {
          sender: 'HOST',
          size: this.filters?.size || 100,
          page: this.filters?.page || 0,
          ...this.filters,
        };

        const response = await generateInvoiceZip(filterParams);

        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/zip' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'host_invoices.zip');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        this.downloadError = this.$t('invoice.downloadError');
        this.showErrorMessage(this.$t('auth.errors.errorGeneratingPdf'));
      } finally {
        this.isDownloading = false;
      }
    },
  },
  mounted() {
    this.fetchCustomerInvoices('HOST');
  },
};
</script>

<style scoped>
.error-text {
  color: red;
}
</style>